import { useEffect, useState } from 'react';

export const useGetFileBlobSrc = (fileBlob?: Blob) => {
  const [sourceUrl, setSourceUrl] = useState<string>();

  useEffect(() => {
    if (!fileBlob) {
      setSourceUrl(undefined);
      return;
    }

    const file = new File([fileBlob], 'ProfileImage');
    const fileUrl = URL.createObjectURL(file);

    setSourceUrl(fileUrl);
  }, [fileBlob]);

  return sourceUrl;
};
